import {TerminalIcon} from '@primer/octicons-react'
import styles from './CliIcon.module.css'

interface CliIconProps {
  showConnectedDot?: boolean
}

export function CliIcon({showConnectedDot = false}: CliIconProps) {
  const ariaLabel = showConnectedDot ? 'Session connected' : 'Remote session'

  return (
    <span className={styles.wrapper} role="img" aria-label={ariaLabel}>
      <TerminalIcon />
      {showConnectedDot && <span data-testid="connected-dot" className={styles.connectedDot} aria-hidden="true" />}
    </span>
  )
}
